<template>
    <div class="relative">
      <Feedback v-if="error" :state="2" :message="error_message"   @unmountFeedComponent="error=false" />
      <LoadingSpinner v-if="loading" color="white" scale="0.4" />

       <b-form class="fast-recharge">
         
          <div class="d-flex justify-content-between" style="margin-bottom: 59px;">
          
            <b-form-group
                  v-if="company.fastRecharge_elements.phone_number"
                  id="input-group-2"
                >
                <label for="phone_number">{{$t('phone_number')}}</label>
                  <b-form-input
                    id="phone_number"
                    v-model="rechargeForm.mobile"
                    type="text"
                    :placeholder="addPlaceHolder(3)"
                    required
                  >
                  </b-form-input>
            </b-form-group>
        

            <b-form-group               
                  v-if="company.fastRecharge_elements.unit_code"
                  id="input-group-3"
                >
                <label for="unit_code">{{$t('unit_code')}}</label>
                <b-form-input
                  id="unit_code"
                  v-model="rechargeForm.unit_code"
                  type="text"
                  :placeholder="addPlaceHolder(2)"
                  required
                ></b-form-input>
             </b-form-group>
            
            <b-form-group               
                  v-if="company.fastRecharge_elements.account_reference"
                  id="input-group-3"
                >
                <label for="account_reference">{{$t('account_reference')}}</label>
                <b-form-input
                  id="account_reference"
                  v-model="rechargeForm.account_reference"
                  type="text"
                  :placeholder="addPlaceHolder(4)"
                  required
                ></b-form-input>
             </b-form-group>
             
             <b-form-group
              v-if="company.fastRecharge_elements.meter_code"
              id="input-group-1"     
            >
            <label for="meter_code">{{$t('meter_code')}}</label>
                <b-form-input
                  id="meter_code"
                  v-model="rechargeForm.meter_code"
                  type="text"
                  :placeholder="addPlaceHolder(1)"
                  required
                ></b-form-input>
             </b-form-group>

            <b-form-group
                v-if="company.fastRecharge_elements.amount"
                id="input-group-4 "
              >
              <label for="recharge_value">{{$t('recharge_value')}}</label>
                <div class="relative">
                  <b-form-input
                    id="recharge_value"
                    v-model="rechargeForm.amount"
                    type="text"
                    :placeholder="$t('recharge_value_placeholder')"
                    required 
                  >
                  </b-form-input>
                  <p class="description">{{$t('min_charge_amount')}} {{rechargeForm.min_charge_amount}} {{$t('egp')}}</p>
                  <span :class="{'absolute currency-left': lang == 1, 'absolute currency-right': lang == 2  }">{{$t('egp')}}</span>
                </div>
                
            </b-form-group>

            <fieldset class="form-group">
              <div class="after-tax-amount">
                <span class="after-tax-amount__title">{{$t('total_after_tax')}}</span>
                <span class="after-tax-amount__value">{{amount_after_tax}} {{$t('egp')}}</span>
              </div>
            </fieldset>

          </div>
       
          <div>
            <b-button
              v-if="rechargeForm.payment_method=='paytabs'"
              v-b-modal.modal-sm
              class="w-100 btn-color"
              style="text-align: center;"
              @click="handleRecharge"
              >{{ $t("Recharge") }}
            </b-button>

            <b-button
              :disabled="(!validateForm()) || rechargeButtonDisabled"
              v-if="rechargeForm.payment_method=='nbe'"
              class="w-100 btn-color"
              style="text-align: center;"
              @click="getMeterDuePayments()"
              >{{ $t("Recharge") }}
            </b-button>

            <b-modal     
              class="model-example"
              id="modal-sm"
              size="sm"
              no-close-on-esc
              no-close-on-backdrop
              :header-class="{
                'right-close': lang == 1,
                'left-close': lang ==2,
              }">
            <div id="payTabs"></div>
            </b-modal>
          </div>
      
      </b-form>
       
       <div class="accepted-payments__container" >
           
          <span>{{$t("We_accept")}}</span>
          
          <img src="../../assets/payment_methods/Visa-logo.png" alt="visa payment method logo"
            style="width: 32.22px;
              height: 26px;">

          <img src="../../assets/payment_methods/Mastercard-logo.png"  alt="mastercard payment method logo"
            style="width: 31.76px;
              height: 24.67px;">

          <img src="../../assets/payment_methods/Meeza-logo.png" alt="meeza payment method logo"
            style="width: 27.83px;
              height: 18px;">
       
       </div>

       <PaymentConfirmation 
        :company="company"
        :lang="lang" 
        :code="rechargeForm.meter_code" 
        :due_payments="PaymentConfirmation.due_payments" 
        :chargeAmount="rechargeForm.amount" 
        :collection_fees="collection_fees" 
        :total_amount="total_amount"
        :financial_dues="0"
        :payment_mode="2"
        @confirm="handleRecharge()"
      />

    </div>

  
</template>

<script>
import Feedback from "@/components/Feedback.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import PaymentConfirmation from "@/components/Recharge/PaymentConfirmation.vue";
import rechargeService from "@/services/recharge";

export default {

  components: {
    Feedback,
    LoadingSpinner,
    PaymentConfirmation
  },

  props:["company","lang"],

  data() {
    return {
      rechargeForm:{
        meter_code:"",
        mobile:"",
        unit_code:"",
        account_reference:"",
        min_charge_amount: 0,
        max_charge_amount:0,
        amount:"",
        checkout:"embedded",
        payment_method:"",
        response_type:"json",
        redirect:true,
      },
      PaymentConfirmation: {
        due_payments: 0,
      },
      rechargeButtonDisabled: false,
      checkoutReady:false,
      error_message:'',
      error:false,
      loading: false,
    }
  },

  created(){
    if(this.company.paytabs==true ) {
      this.rechargeForm.payment_method="paytabs";
    }
    else  this.rechargeForm.payment_method ="nbe";

    this.rechargeForm.min_charge_amount=this.company.fastRechargeLimit.min;
    this.rechargeForm.max_charge_amount=this.company.fastRechargeLimit.max;
    
  },

  computed: {
    amount_after_tax() {
      if(this.rechargeForm.amount == 0) return 0; 

      return this.calcTax(this.rechargeForm.amount)
    },

    collection_fees() {
      if((Number(this.PaymentConfirmation.due_payments) + Number(this.rechargeForm.amount)) > 0)
        return parseFloat(( (Number(this.PaymentConfirmation.due_payments) + Number(this.rechargeForm.amount))  * this.company.fees_precentage)).toFixed(2);
      else 
        return 0 ;
    },

    total_amount() {
      return parseFloat( Number(this.rechargeForm.amount) + Number(this.PaymentConfirmation.due_payments) + Number(this.collection_fees) ).toFixed(2);
    }
  },

  methods: {
   
    validateMeterNumber() {
      return this.rechargeForm.meter_code != ''
    },
   
    validateAccountReference() {
    return this.rechargeForm.account_reference != ''
    },

    validateRechargeAmount() {
    const amount = this.rechargeForm.amount
    return (
      amount != '' && 
      amount != false && 
      amount != null && amount >= this.rechargeForm.min_charge_amount

      )
    },


    validateForm() {
      return this.validateMeterNumber() && this.validateAccountReference() && this.validateRechargeAmount(); 
    },

    addPlaceHolder(tybe){
    if(tybe==1)  {
      //meter
      return this.lang==2 ? this.company.fastRecharge_elements.meter_placeholder_en 
                              : this.company.fastRecharge_elements.meter_placeholder_ar; 
    }
    else if(tybe==2){
      //unit
      return this.lang==2 ? this.company.fastRecharge_elements.unit_placeholder_en 
                              : this.company.fastRecharge_elements.unit_placeholder_ar;   
    }
    else if(tybe==3){
      return this.lang==2 ? this.company.fastRecharge_elements.phone_number_placeholder_en 
                              : this.company.fastRecharge_elements.phone_number_placeholder_ar; 
    } else if(tybe==4){
      return this.lang==2 ? this.company.fastRecharge_elements.account_reference_placeholder_en 
                              : this.company.fastRecharge_elements.account_reference_placeholder_ar; 
    }
    },

    calcTax(amount) {
      return (Number(amount) + Number.EPSILON + Number(amount *this.company.fees_precentage)).toFixed(2)
    },

    showModal(ref) {
      this.$bvModal.show(ref)
    },

    getMeterDuePayments() {
      const amount = this.rechargeForm.amount;
      if (amount > this.rechargeForm.max_charge_amount) {
        this.rechargeButtonDisabled = false; 
       this.error = true; 
       this.error_message =this.$t('max_recharge_amount') +" "+  this.rechargeForm.max_charge_amount;   
      }
      else{
        this.rechargeButtonDisabled = true; 
      this.error = false; 

      rechargeService.meterDuePayments(this.rechargeForm.account_reference , this.rechargeForm.meter_code, this.lang)
      .then(data => {
        this.rechargeButtonDisabled = false; 
        this.showModal("paymentConfirmation")
        this.PaymentConfirmation.due_payments = Number(data.min_charge_value)
      })
      .catch(err => {
        this.rechargeButtonDisabled = false; 
        let msg = this.$t('something_went_wrong')
           if(err.message===-102) {
            msg = msg  + " " + this.$t('try_again_later')
          } else {
            msg = msg + " " + err.message
          }
          this.error = true;
          this.error_message = msg;
      })
      }
      
    },

    handleRecharge(){
      this.loading = true ; 

      this.rechargeForm.amount=Number(this.rechargeForm.amount);
      rechargeService.fastRecharge(this.rechargeForm, this.total_amount, this.collection_fees)
      .then(data=>{
        if(this.rechargeForm.payment_method==="nbe"){                
            if (data.session_id !== '') {
              checkoutPrepare(data.session_id, data.merchant, data.merch_name,data.total_amount, data.request_number, this.rechargeForm.account_reference,data.session_version)
                  Checkout.showLightbox()
                  this.loading = false ;
            } else {
              throw new Error("");
            }
        }
        else {
          let PaymentLink=data.redirect_url;  
            if(PaymentLink != null) {
              let payTabsIframe = document.getElementById('payTabs');
              payTabsIframe.innerHTML = "";
              let frame = document.createElement('iframe');
              payTabsIframe.classList.add('iframe-show')
              frame.src = PaymentLink
              
              payTabsIframe.appendChild(frame);
              this.loading = false ;
            }
            else
              throw Error("No Link");
        }
      })
      .catch(err => {
          let msg = this.$t('something_went_wrong')
          if(err.message===-102) {
            msg = msg  + " " + this.$t('try_again_later')
          } else {
            msg = msg + " " + err.message
          }
          this.loading = false ;
            this.error = true;
            this.error_message = msg;
        });
        
    },

  },

};
</script>

<style scoped>
@import url("../../assets/styles/form.css");


#modal-sm___BV_modal_header_ {
  /* margin-bottom: 10px; */
  border-bottom: 0.5px solid #eee !important;
}

#modal-sm___BV_modal_header_ .close {
  background-color: transparent !important;
  color: #777 !important;

  margin-left: -5px !important;
  border: none !important;
  font-size: 2rem;
}



.right-close {
  justify-content: start !important;
}
.left-close {
  justify-content: end !important;
}

.modal-header {
  border: none;
  padding: 0;
  /* padding-right: 5px  !important; */
  margin: 0;
}

.modal-content {
      overflow-y: auto !important;
    /* height: 90vh;s */
    width: 400px;
    /* margin-left: -50px; */
}
.modal-footer {
  display: none;
}

.active {
  color: var(--main-color) !important;
}

/* --------------------------------------------------------- */

#payTabs{
     width: 100%;
    height: 100%;
  /* margin: auto; */
}

#payTabs iframe{
width:100%;
height:100%;
}

/* --------------------------------------------------------- */

.fast-recharge .form-control{
  width: 100% !important;
}

.fast-recharge div {
  width: 100%;
  column-gap: 16px;
  row-gap: 16px;
  flex-wrap: wrap;
}

.fast-recharge div .form-group{
  width: 48%;
  flex: 1 auto;
  margin-bottom: 0px;
}

/* --------------------------------------------------------- */

.currency-left {
  position: absolute;
  left: 16px;
  top: 10px;
  color: #4F4D61;
}

.currency-right {
  position: absolute;
  right: 16px;
  top: 10px;
  color: #4F4D61;
}

/* --------------------------------------------------------- */

.after-tax-amount {
  width:48%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 4px !important;
  height: 100%;
}

.after-tax-amount__title {
  font-weight: 500 !important;
  font-size: 14px;
  line-height: 17px;
}

.after-tax-amount__value {
  font-weight: 500 !important;
  font-size: 16px;
  line-height: 20px;
  color: #E94C28;
}

/* --------------------------------------------------------- */

.accepted-payments__container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  color: #2C3E50;
}

.accepted-payments__container span {
  font-size: 14px;
}
</style>
